export const PROVIDER_REFERRAL_PROGRAM_MVP_FLAG_NAME: string = 'provider_referral_program_mvp_20201021';
